import React from "react";
// import TransparentHeader from "./TransparentHeader";
import Header from "./Header";

const InvalidPage = () => {
  return (
    <div>
      {/* <TransparentHeader/> */}
      <Header/>
      <div style={styles.container}>
        <div style={styles.centeredDiv}>
          <h4>404 - Invalid URL</h4>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  centeredDiv: {
    padding: "30px",
    backgroundColor: "#acc7ec",
    color: "black",
    fontSize: "24px",
    textAlign: "center",
    borderRadius: "8px",
  },
};

export default InvalidPage;
